export default __webpack_public_path__ + "static/bg-green-f34566d7d85087e677044864369f6ff1.png";